// @ts-nocheck
/* eslint-disable */
import { store } from "~/state/store";
import { node, text, icon } from "~/util/dom";
import { sklikPhotoUpload } from "~/util/sklik";
import { CONFIG } from "~/config";
import ContentFull from "~/content.full";
import { _ } from "~/i18n";
import Scene from "~/scene";
import * as Provider from "~/util/providers/photo";
import { isDetailActive } from "~/util/detail";
import { addActiveContent, removeActiveContent } from "./state/ribbon/state";

/**
*  Komponenta (overlay) zastresujici nahravani fotografii a aditaci nahranych fotografii
*/
(function() {
	const NO_POI_SOURCE = 0;
	const MIME_TYPES = [
		"image/jpeg",
		"image/pjpeg",
		"image/png"
	];
	const UPLOAD_URL = CONFIG.BASE_DOMAIN === CONFIG.BASE_COM_DOMAIN ? `https://upload.${CONFIG.BASE_DOMAIN}` : `https://upload.mapy.${CONFIG.TLD}`;

	class ImageUploader extends ContentFull {
		constructor() {
			super();
			this._contentName = "image-uploader";
			this._dom = {
				container: node("div", {id:"image-uploader"}),
				uploadButton: node("label", { className: `upload-button ui-header-button` }),
				iframe: null,
				uploadButtons: []
			};
			this._dom.uploadButton.setAttribute("data-log-origin", "fotky");
			this._dom.uploadButton.setAttribute("data-log-action", "click");
			this._param = null;
			this._postMessage = null;
			this._layout = Mapy.getComponent("layout");
			this._buildCloseButton();
			this._mapCoords = null;

			this._dom.uploadButton.appendChild(text(_("mymap.imageUploader.title")));
			this._oldBrowser = !("FileReader" in window); // formdata a filereader maji stejnou dostupnost

			if (!this._oldBrowser) {
				window.addEventListener("message", this);
			}
		}

		activate() {
			if (this.isActive()) { return this; }

			if (this._oldBrowser) {
				window.addEventListener("keydown", this, false);
				this._showOldBrowserInfo();
				return super.activate();
			}
			else return this;
		}

		deactivate() {
			if (!this.isActive()) { return this; }

			if(this._dom.noSupportedInfo) {
				this._dom.noSupportedInfo.remove();
				window.removeEventListener("keydown", this, false);
				return super.deactivate();
			}
			else return this;
		}

		hide() {
			this._hidden = true;
			return super.hide();
		}

		show() {
			this._hidden = false;
			return super.show();
		}

		getNoSupportedInfo() {
			return this._buildOldBrowserInfo();
		}

		setData(param) {
			this._param = param;

			// editace a nepodporovany prohlizec
			if(param.editMode && this._oldBrowser) {
				this.activate();
				return;
			}

			this._createIframe();
		}

		setMapCoords(coords) {
			this._mapCoords = coords;
		}

		getContainer() {
			return this._dom.container;
		}

		getUploadBox(data) {
			var node = this._dom.uploadButton.cloneNode(true);
			node.setAttribute('data-log-type', data && data.source === 'coor' ? 'coor' : 'poi');
			node.addEventListener("click", this, false);
			this._dom.uploadButtons.push(node);
			return node;
		}

		removeUploadBox(node) {
			var index = this._dom.uploadButtons.indexOf(node);
			if(index < 0) { return }
			node.removeEventListener("click", this, false);
		}

		getState() {
			return {};
		}

		setState(param) {
		}

		dropFiles(files) {
			var param = {
				poi: this._getPoiData(),
				source: "mapy",
				type: "empty",
			};
			this._postMessage = () => {
				this._dom.iframe.contentWindow.postMessage({ type: "upload", files }, UPLOAD_URL);
			}
			this.setData(param);
		}

		_click(e) {
			if (this._oldBrowser) {
				this.activate();
			}
			else {
				var poiData = this._getPoiData();
				var param = {
					poi: poiData,
					source: e.target.hasAttribute("data-log-source") ? e.target.getAttribute("data-log-source") : "mapy",
					type: e.target.hasAttribute("data-log-type") ? e.target.getAttribute("data-log-type") : "empty",
				}

				this.setData(param);
			}
		}

		handleEvent(e) {
			switch (e.type) {
				case "click":
					const user = store.getState().user.user;

					if (user.state === "green") {
						this._click(e);
					} else {
						Mapy.getComponent("login").open({
							analyticsData: {
								loginOrigin: "photoUpload",
							},
							motivation: "photo",
						}).then(() => {
							this._click(e);
						}, _e => {});
					}
					break;

				case "keydown":
					if (e.keyCode == 27) { /* esc */
						this.deactivate();
					}
					break;

				case "message":
					switch (e.data.type) {
						case "mapy-upload-ready":
							if (typeof this._postMessage === "function") {
								this._postMessage();
								this._postMessage = null;
							}
							break;
						case "mapy-upload-close":
							this._refreshContent();
							this._closeIframe();
							break;
						case "mapy-upload-success":
							sklikPhotoUpload();
							this._closeIframe();
							if (e.data.numFailed && e.data.numFailed > 0) {
								// nektere selhaly, takze zadny dialog, jen varovnou notifikaci
								this._createFailurePopup({
									content: _("imageUploader2.successPartial")
								});
							} else {
								// vytvorime dialog o nahrani
								this._createSuccessPopup(e.data.added);
							}
							break;
						case "mapy-upload-failure":
							this._closeIframe();
							// vytvorime dialog pri chybe
							this._createFailurePopup({
								content: _("imageUploader2.errorDesc")
							});
							break;
					}
					break;
			}
		}

		_showOldBrowserInfo() {
			if(!this._dom.noSupportedInfo) {
				this._dom.noSupportedInfo = Mapy.Util.createBigOldBrowserInfo();
			}
			this._dom.container.appendChild(this._dom.noSupportedInfo);
		}

		_getPoiData() {
			const state = store.getState();
			const { longitude, latitude } = state;
			const { data } = state.detail;

			if (data) {
				const { source, id } = data;

				return { source, id };
			} else {
				const source = Mapy.ImageUploader.NO_POI_SOURCE;
				const coords = Scene.coordsFromWGS84(longitude, latitude);
				// FIXME: tohle je podle me spatne, ale nechci rozbit nevedomky neco, cemu nerozumim, tak nechavam tak, jak je
				const id = coords.toWGS84(2).reverse().join(", ");

				return { source, id };
			}
		}

		_createIframe() {
			// vytvorime iframe
			let iframe = node("iframe", { className: "imageuploader-iframe" });
			iframe.setAttribute("frameborder", "0");
			iframe.setAttribute("allow-same-origin", "true");
			iframe.style.zIndex = "0";
			this._layout.createLoader();
			iframe.addEventListener("load", e => {
				this._layout.removeLoader();
				document.body.classList.add("upload-iframe");
				iframe.style.removeProperty("z-index");
			});
			iframe.addEventListener("error", e => {
				this._layout.removeLoader();
			});
			const instanceId = "getInstanceId" in window ? `&instanceid=${window.getInstanceId()}` : "";
			let src = `${UPLOAD_URL}/?lang=${CONFIG.defaultLang}&modal=1&service=${encodeURIComponent(this._param.source || "mapy")}${instanceId}&`;

			if (this._mapCoords) {
				src += `longitude=${this._mapCoords.longitude}&latitude=${this._mapCoords.latitude}&zoom=${this._mapCoords.zoom}&`;
			}

			// prihlaseny posle do URL jeste svoje publicId
			const { user } = store.getState().user;

			if (user.state === "green" && user.userPublicId) {
				src += `user=${user.userPublicId}&`;
			}

			if (this._param.editMode) {
				iframe.src = `${src}mediaid=${this._param.poi.id}`;
				iframe.setAttribute("allowtransparency", "true");
			}
			else if (this._param.poi.source && this._param.poi.id) {
				iframe.src = `${src}source=${this._param.poi.source}&id=${encodeURIComponent(this._param.poi.id)}`;
			}
			else {
				iframe.src = src;
			}

			document.body.appendChild(iframe);
			store.dispatch(addActiveContent("photo-upload"));
			this._dom.iframe = iframe;
		}

		_closeIframe() {
			document.body.classList.remove("upload-iframe");
			if (this._dom.iframe) {
				this._dom.iframe.remove();
			}
			this._dom.iframe = null;
			store.dispatch(removeActiveContent("photo-upload"));
		}

		_createSuccessPopup(added) {
			// dialog
			let cover = node("div", { className: "imageuploader-cover" });
			let popup = node("div", { className: "imageuploader-popup" });
			popup.appendChild(icon("love"));
			let crossBtn = node("button", { className: "cross-btn" });
			crossBtn.appendChild(icon("close"));
			crossBtn.setAttribute("data-log-origin", "fotky-step2");
			crossBtn.setAttribute("data-log-source", this._param.source || "mapy");
			crossBtn.setAttribute("data-log-type", this._param.type || "empty");
			popup.appendChild(crossBtn);
			popup.appendChild(node("h2", { textContent: _("imageUploader2.title") }));
			popup.appendChild(node("p", { textContent: _("imageUploader2.desc") }));
			let buttons = node("div", { className: "buttons" });
			let anotherBtn = node("button", { className: "another-btn", textContent: _("imageUploader2.uploadAnother") });
			anotherBtn.setAttribute("data-log-origin", "fotky-step2");
			anotherBtn.setAttribute("data-log-source", this._param.source || "mapy-another_upload");
			anotherBtn.setAttribute("data-log-type", this._param.type || "empty");
			let closeBtn = node("button", { className: "close-btn", textContent: _("close") });
			closeBtn.setAttribute("data-log-origin", "fotky-step2");
			closeBtn.setAttribute("data-log-source", this._param.source || "mapy");
			closeBtn.setAttribute("data-log-type", this._param.type || "empty");
			popup.appendChild(buttons);
			buttons.appendChild(anotherBtn);
			buttons.appendChild(closeBtn);
			document.body.appendChild(cover);
			document.body.appendChild(popup);

			// callback pro zavreni dialogu
			let closeCb = reloadPhotos => {
				cover.remove();
				popup.remove();

				if (reloadPhotos) {
					this._refreshContent(added);
				}
			};

			anotherBtn.addEventListener("click", e => {
				closeCb();
				this.setData(this._param);
			});
			closeBtn.addEventListener("click", e => {
				closeCb(true);
			});
			crossBtn.addEventListener("click", e => {
				closeCb(true);
			});
		}

		_createFailurePopup(conf) {
			// dialog
			let cover = node("div", { className: "imageuploader-cover" });
			let popup = node("div", { className: "imageuploader-popup failure" });
			let crossBtn = node("button", { className: "cross-btn" });
			crossBtn.appendChild(icon("close"));
			popup.appendChild(crossBtn);
			popup.appendChild(node("h2", { textContent: _("imageUploader2.errorTitle") }));
			popup.appendChild(node("p", { textContent: conf.content }));
			let buttons = node("div", { className: "buttons" });
			let anotherBtn = node("button", { className: "another-btn", textContent: _("imageUploader2.tryAgain") });
			let closeBtn = node("button", { className: "close-btn", textContent: _("cancel") });
			popup.appendChild(buttons);
			buttons.appendChild(closeBtn);
			buttons.appendChild(anotherBtn);
			document.body.appendChild(cover);
			document.body.appendChild(popup);

			// callback pro zavreni dialogu
			let closeCb = () => {
				cover.remove();
				popup.remove();
			};

			anotherBtn.addEventListener("click", e => {
				closeCb();
				this.setData(this._param);
			});
			closeBtn.addEventListener("click", e => {
				closeCb();
			});
			crossBtn.addEventListener("click", e => {
				closeCb();
			});
		}

		_refreshContent(added) {
			// refresh detailu
			if (isDetailActive(store.getState())) {
				// musi byt timeout - pokud ulozim/upravim media a zavolam poiagg, tak se zmeny neprojevi
				setTimeout(() => {
					Mapy.getComponent("detail").reload();
					Mapy.getComponent("pois").forceRequest(true);
				}, 500);
			}

			if (Mapy.getComponent("gallery").isActive()) {
				let gallery = Mapy.getComponent("gallery");
				let detail = Mapy.getComponent("photoDetail");
				let state = gallery.getData();

				gallery.close();
				Provider.clear(state.source, state.id);

				if (detail.isActive()) {
					let detailState = detail.getState();

					detail.deactivate();

					Provider.clear(detailState.sourcep, detailState.idp);

					Object.assign(state, detailState);
				}

				if (state.source && state.source !== "author") {
					state.gallery = 1;
				}

				if (added) {
					state.coords = added.map(photo => SMap.Coords.fromWGS84(photo.mark.lon, photo.mark.lat))
				}

				gallery.setState(state);
			}
			else if (Mapy.getComponent("photoDetail").isActive()) {
				Mapy.getComponent("photoDetail").reload(true);
			}
		}
	}

	Mapy.ImageUploader = ImageUploader;
	Mapy.ImageUploader.MIME_TYPES = MIME_TYPES;
	Mapy.ImageUploader.NO_POI_SOURCE = NO_POI_SOURCE;
})();
